import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { ImpactAssessmentT5Filter, ImpactAssessmentT5MasterFilter } from 'src/app/core/models/impact-assessment/impact-assessmentT5';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { ImpactService } from 'src/app/core/services/impact/impact.service';
import { MasterHelper } from 'src/app/core/utilities';

@Component({
  selector: 'app-impact-assessment-t5-filter',
  templateUrl: './impact-assessment-t5-filter.component.html',
  styleUrls: ['./impact-assessment-t5-filter.component.scss']
})
export class ImpactAssessmentT5FilterComponent {

  @Output() OnFilterT5 = new EventEmitter<any>();
  impactAssessmentFilter: ImpactAssessmentT5Filter;
  masterFilters: ImpactAssessmentT5MasterFilter;
  filterPersistenceKey = 'impactAssessmentT5Filters';
  isPersistFilter = false;
  filteredKeywords: string[];
  isLoadingFilters = false;

  searchedTeam: FilterViewModel[] = [];
  searchedNP: FilterViewModel[] = [];
  searchedRuleType: FilterViewModel[] = [];
  searchedRR: FilterViewModel[] = [];
  searchedRA: FilterViewModel[] = [];
  searchedCS: FilterViewModel[] = [];
  searchedJ: FilterViewModel[] = [];
  searchedEP: FilterViewModel[] = [];
  searchedPRA: FilterViewModel[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];

  searchTeamCntrl: FormControl = new FormControl();
  searchNPCntrl: FormControl = new FormControl();
  searchRuleTypeCntrl: FormControl = new FormControl();
  searchRRCntrl: FormControl = new FormControl();
  searchRACntrl: FormControl = new FormControl();
  searchCSCntrl: FormControl = new FormControl();
  searchJCntrl: FormControl = new FormControl();
  searchEPCntrl: FormControl = new FormControl();
  searchPRACntrl: FormControl = new FormControl();
  keyCtrl = new FormControl();

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;

  @ViewChild('teamInput')
  teamInput!: ElementRef<HTMLInputElement>;
  @ViewChild('teamAutocomplete')
  teamAutocomplete!: MatAutocomplete;

  @ViewChild('nPInput')
  nPInput!: ElementRef<HTMLInputElement>;
  @ViewChild('nPAutocomplete')
  nPAutocomplete!: MatAutocomplete;

  @ViewChild('rTypeInput')
  rTypeInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rTypeAutocomplete')
  rTypeAutocomplete!: MatAutocomplete;

  @ViewChild('rRInput')
  rRInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rRAutocomplete')
  rRAutocomplete!: MatAutocomplete;

  @ViewChild('rAInput')
  rAInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rAAutocomplete')
  rAAutocomplete!: MatAutocomplete;

  @ViewChild('cSInput')
  cSInput!: ElementRef<HTMLInputElement>;
  @ViewChild('cSAutocomplete')
  cSAutocomplete!: MatAutocomplete;

  @ViewChild('jInput')
  jInput!: ElementRef<HTMLInputElement>;
  @ViewChild('jAutocomplete')
  jAutocomplete!: MatAutocomplete;

  @ViewChild('ePInput')
  ePInput!: ElementRef<HTMLInputElement>;
  @ViewChild('ePAutocomplete')
  ePAutocomplete!: MatAutocomplete;

  @ViewChild('prAInput')
  prAInput!: ElementRef<HTMLInputElement>;
  @ViewChild('prAAutocomplete')
  prAAutocomplete!: MatAutocomplete;

  @ViewChild('autoKeyword') autoKeyword!: MatAutocomplete;
  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;

  constructor(private impactService: ImpactService) {
    this.impactAssessmentFilter = new ImpactAssessmentT5Filter();
    this.masterFilters = new ImpactAssessmentT5MasterFilter();

    let strImp = this.fetchFromBrowser(
      this.filterPersistenceKey
    ) as string;
    const persistFilter = JSON.parse(strImp) as ImpactAssessmentT5Filter;
    if (persistFilter && !persistFilter.updatesDBId) {
      persistFilter.updatesDBId = [];
      this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(persistFilter));
    }
    if (persistFilter) {
      this.isPersistFilter = true;
      this.impactAssessmentFilter = persistFilter;
    }
    this.filteredKeywords = [];
  }

  ngOnInit(): void {
    this.getMasterFilters();
  }

  initFilters(): void {
    this.impactAssessmentFilter.updatesDBId = [];
    this.impactAssessmentFilter.team = [];
    this.impactAssessmentFilter.searchQuery = [];
    this.impactAssessmentFilter.jurisdiction = [];
    this.impactAssessmentFilter.namedPersonnel = [];
    this.impactAssessmentFilter.currentStatus = [];
    this.impactAssessmentFilter.engagementplan = [];
    this.impactAssessmentFilter.policyResponseAchieved = [];
    this.impactAssessmentFilter.ragRating = [];
    this.impactAssessmentFilter.responseApproach = [];
    this.impactAssessmentFilter.ruleType = [];
    this.impactAssessmentFilter.fromDate = this.masterFilters.fromDate.toString();
    this.impactAssessmentFilter.toDate = this.masterFilters.toDate.toString();
    this.searchedTeam = this.masterFilters.team;
    this.searchedNP = this.masterFilters.namedPersonnel;
    this.searchedRuleType = this.masterFilters.ruleType;
    this.searchedRR = this.masterFilters.ragRating;
    this.searchedRA = this.masterFilters.responseApproach;
    this.searchedCS = this.masterFilters.currentStatus;
    this.searchedEP = this.masterFilters.engagementplan;
    this.searchedPRA = this.masterFilters.policyResponseAchieved;
    this.searchedJ = this.masterFilters.jurisdiction;
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.impactAssessmentFilter));
    this.OnFilterT5.emit(this.impactAssessmentFilter);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  getMasterFilters(): void {
    this.isLoadingFilters = true;
    this.impactService.getImpactAssessmentT5MasterFilters().subscribe((result: ImpactAssessmentT5MasterFilter) => {
      this.masterFilters = result;
      this.impactAssessmentFilter.fromDate = this.masterFilters.fromDate.toString();
      this.impactAssessmentFilter.toDate = this.masterFilters.toDate.toString();
      this.searchedTeam = this.masterFilters.team;
      this.searchedNP = this.masterFilters.namedPersonnel;
      this.searchedRuleType = this.masterFilters.ruleType;
      this.searchedRR = this.masterFilters.ragRating;
      this.searchedRA = this.masterFilters.responseApproach;
      this.searchedCS = this.masterFilters.currentStatus;
      this.searchedEP = this.masterFilters.engagementplan;
      this.searchedPRA = this.masterFilters.policyResponseAchieved;
      this.searchedJ = this.masterFilters.jurisdiction;
      this.isLoadingFilters = false;


      this.searchTeamCntrl.valueChanges.subscribe((data: any) => {
        this.searchedTeam = data ? this.filterData(data, 'Team') : this.masterFilters.team;
      });
      this.searchNPCntrl.valueChanges.subscribe((data: any) => {
        this.searchedNP = data ? this.filterData(data, 'NamedPersonal') : this.masterFilters.namedPersonnel;
      });
      this.searchRuleTypeCntrl.valueChanges.subscribe((data: any) => {
        this.searchedRuleType = data ? this.filterData(data, 'RuleType') : this.masterFilters.ruleType;
      });
      this.searchRRCntrl.valueChanges.subscribe((data: any) => {
        this.searchedRR = data ? this.filterData(data, 'RagRating') : this.masterFilters.ragRating;
      });
      this.searchRACntrl.valueChanges.subscribe((data: any) => {
        this.searchedRA = data ? this.filterData(data, 'ResponseApproach') : this.masterFilters.responseApproach;
      });
      this.searchCSCntrl.valueChanges.subscribe((data: any) => {
        this.searchedCS = data ? this.filterData(data, 'CurrentStatus') : this.masterFilters.currentStatus;
      });
      this.searchEPCntrl.valueChanges.subscribe((data: any) => {
        this.searchedEP = data ? this.filterData(data, 'EngagementPlan') : this.masterFilters.engagementplan;
      });
      this.searchPRACntrl.valueChanges.subscribe((data: any) => {
        this.searchedPRA = data ? this.filterData(data, 'PolicyResponseAchieved') : this.masterFilters.policyResponseAchieved;
      });

      this.searchJCntrl.valueChanges.subscribe((data: any) => {
        this.searchedJ = data ? this.filterData(data, 'Jurisdiction') : this.masterFilters.jurisdiction;
      });
    });
  }

  filterData(search: string, filter: string): any {
    switch (filter) {
      case 'Team':
        return this.searchedTeam.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
        break;
      case 'NamedPersonal':
        return this.searchedNP.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
        break;
      case 'RuleType':
        return this.searchedRuleType.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
        break;
      case 'RagRating':
        return this.searchedRR.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
        break;
      case 'ResponseApproach':
        return this.searchedRA.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
        break;
      case 'CurrentStatus':
        return this.searchedCS.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
        break;
      case 'EngagementPlan':
        return this.searchedEP.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
        break;
      case 'PolicyResponseAchieved':
        return this.searchedPRA.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
        break;
      case 'Jurisdiction':
        return this.searchedJ.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
        break;
      default:
        return new Array<FilterViewModel>();
        break;
    }
  }
  triggerAction(): void {
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.impactAssessmentFilter));
    this.OnFilterT5.emit(this.impactAssessmentFilter);
  }

  //Team Events
  addTeam(event: MatChipInputEvent): void {
    if (!this.teamAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.impactAssessmentFilter.team as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchTeamCntrl.setValue(null);
    }
  }

  selectedTeamEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.team) {
      let filterRow=this.impactAssessmentFilter.team.filter(a=>a==event.option.viewValue);
      if(filterRow.length==0){
        this.impactAssessmentFilter.team.push(event.option.viewValue);
      }
    } else {
      this.impactAssessmentFilter.team = [];
      this.impactAssessmentFilter.team.push(event.option.viewValue);
    }
    if (this.teamInput) {
      this.teamInput.nativeElement.value = '';
    }
    this.searchTeamCntrl.setValue(null);
    this.searchTeamCntrl.disable();
    this.searchTeamCntrl.enable();
  }

  removeTeam(status: string): void {
    const index = (this.impactAssessmentFilter.team as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactAssessmentFilter.team as string[]).splice(index, 1);
    }
  }

  //Named Personal Events
  addNP(event: MatChipInputEvent): void {
    if (!this.nPAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.impactAssessmentFilter.namedPersonnel as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchNPCntrl.setValue(null);
    }
  }

  selectedNPEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.namedPersonnel) {
      let filterRow=this.impactAssessmentFilter.namedPersonnel.filter(a=>a==event.option.viewValue);
      if(filterRow.length==0){
        this.impactAssessmentFilter.namedPersonnel.push(event.option.viewValue);
      }
    } else {
      this.impactAssessmentFilter.namedPersonnel = [];
      this.impactAssessmentFilter.namedPersonnel.push(event.option.viewValue);
    }
    if (this.nPInput) {
      this.nPInput.nativeElement.value = '';
    }
    this.searchNPCntrl.setValue(null);
    this.searchNPCntrl.disable();
    this.searchNPCntrl.enable();
  }

  removeNP(status: string): void {
    const index = (this.impactAssessmentFilter.namedPersonnel as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactAssessmentFilter.namedPersonnel as string[]).splice(index, 1);
    }
  }

  //Rule Type Events
  addRT(event: MatChipInputEvent): void {
    if (!this.rTypeAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.impactAssessmentFilter.ruleType as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchRuleTypeCntrl.setValue(null);
    }
  }

  selectedRTEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.ruleType) {
      let filterRow=this.impactAssessmentFilter.ruleType.filter(a=>a==event.option.viewValue);
      if(filterRow.length==0){
        this.impactAssessmentFilter.ruleType.push(event.option.viewValue);
      }
    } else {
      this.impactAssessmentFilter.ruleType = [];
      this.impactAssessmentFilter.ruleType.push(event.option.viewValue);
    }
    if (this.rTypeInput) {
      this.rTypeInput.nativeElement.value = '';
    }
    this.searchRuleTypeCntrl.setValue(null);
    this.searchRuleTypeCntrl.disable();
    this.searchRuleTypeCntrl.enable();
  }

  removeRT(status: string): void {
    const index = (this.impactAssessmentFilter.ruleType as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactAssessmentFilter.ruleType as string[]).splice(index, 1);
    }
  }

  //Rag Rating Events
  addRR(event: MatChipInputEvent): void {
    if (!this.rRAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.impactAssessmentFilter.ragRating as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchRRCntrl.setValue(null);
    }
  }

  selectedRREvent(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.ragRating) {
      let filterRow=this.impactAssessmentFilter.ragRating.filter(a=>a==event.option.viewValue);
      if(filterRow.length==0){
        this.impactAssessmentFilter.ragRating.push(event.option.viewValue);
      }
    } else {
      this.impactAssessmentFilter.ragRating = [];
      this.impactAssessmentFilter.ragRating.push(event.option.viewValue);
    }
    if (this.rRInput) {
      this.rRInput.nativeElement.value = '';
    }
    this.searchRRCntrl.setValue(null);
    this.searchRRCntrl.disable();
    this.searchRRCntrl.enable();
  }

  removeRR(status: string): void {
    const index = (this.impactAssessmentFilter.ragRating as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactAssessmentFilter.ragRating as string[]).splice(index, 1);
    }
  }

  //Response Approach Events
  addRA(event: MatChipInputEvent): void {
    if (!this.rAAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.impactAssessmentFilter.responseApproach as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchRACntrl.setValue(null);
    }
  }

  selectedRAEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.responseApproach) {
      let filterRow=this.impactAssessmentFilter.responseApproach.filter(a=>a==event.option.viewValue);
      if(filterRow.length==0){
        this.impactAssessmentFilter.responseApproach.push(event.option.viewValue);
      } 
    } else {
      this.impactAssessmentFilter.responseApproach = [];
      this.impactAssessmentFilter.responseApproach.push(event.option.viewValue);
    }
    if (this.rAInput) {
      this.rAInput.nativeElement.value = '';
    }
    this.searchRACntrl.setValue(null);
    this.searchRACntrl.disable();
    this.searchRACntrl.enable();
  }

  removeRA(status: string): void {
    const index = (this.impactAssessmentFilter.responseApproach as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactAssessmentFilter.responseApproach as string[]).splice(index, 1);
    }
  }

  //Current Status Events
  addCS(event: MatChipInputEvent): void {
    if (!this.cSAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.impactAssessmentFilter.currentStatus as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchCSCntrl.setValue(null);
    }
  }

  selectedCSEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.currentStatus) {
      let filterRow=this.impactAssessmentFilter.currentStatus.filter(a=>a==event.option.viewValue);
      if(filterRow.length==0){
        this.impactAssessmentFilter.currentStatus.push(event.option.viewValue);
      } 
    } else {
      this.impactAssessmentFilter.currentStatus = [];
      this.impactAssessmentFilter.currentStatus.push(event.option.viewValue);
    }
    if (this.cSInput) {
      this.cSInput.nativeElement.value = '';
    }
    this.searchCSCntrl.setValue(null);
    this.searchCSCntrl.disable();
    this.searchCSCntrl.enable();
  }

  removeCS(status: string): void {
    const index = (this.impactAssessmentFilter.currentStatus as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactAssessmentFilter.currentStatus as string[]).splice(index, 1);
    }
  }

  //Engagement Plan Events
  addEP(event: MatChipInputEvent): void {
    if (!this.ePAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.impactAssessmentFilter.engagementplan as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchEPCntrl.setValue(null);
    }
  }

  selectedEPEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.engagementplan) {
      let filterRow=this.impactAssessmentFilter.engagementplan.filter(a=>a==event.option.viewValue);
      if(filterRow.length==0){
        this.impactAssessmentFilter.engagementplan.push(event.option.viewValue);
      } 
    } else {
      this.impactAssessmentFilter.engagementplan = [];
      this.impactAssessmentFilter.engagementplan.push(event.option.viewValue);
    }
    if (this.ePInput) {
      this.ePInput.nativeElement.value = '';
    }
    this.searchEPCntrl.setValue(null);
    this.searchEPCntrl.disable();
    this.searchEPCntrl.enable();
  }

  removeEP(status: string): void {
    const index = (this.impactAssessmentFilter.engagementplan as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactAssessmentFilter.engagementplan as string[]).splice(index, 1);
    }
  }

  //Policy Response Achieved Events
  addPRA(event: MatChipInputEvent): void {
    if (!this.prAAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.impactAssessmentFilter.policyResponseAchieved as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchPRACntrl.setValue(null);
    }
  }

  selectedPRAEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.policyResponseAchieved) {
      let filterRow=this.impactAssessmentFilter.policyResponseAchieved.filter(a=>a==event.option.viewValue);
      if(filterRow.length==0){
        this.impactAssessmentFilter.policyResponseAchieved.push(event.option.viewValue);
      }
    } else {
      this.impactAssessmentFilter.policyResponseAchieved = [];
      this.impactAssessmentFilter.policyResponseAchieved.push(event.option.viewValue);
    }
    if (this.prAInput) {
      this.prAInput.nativeElement.value = '';
    }
    this.searchPRACntrl.setValue(null);
    this.searchPRACntrl.disable();
    this.searchPRACntrl.enable();
  }

  removePRA(status: string): void {
    const index = (this.impactAssessmentFilter.policyResponseAchieved as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactAssessmentFilter.policyResponseAchieved as string[]).splice(index, 1);
    }
  }

  // Jurisdiction events
  addJurisdiction(event: MatChipInputEvent): void {
    if (!this.jAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.impactAssessmentFilter.jurisdiction as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchJCntrl.setValue(null);
    }
  }

  selectedJurisdictionEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.jurisdiction) {
      let filterRow=this.impactAssessmentFilter.jurisdiction.filter(a=>a==event.option.viewValue);
      if(filterRow.length==0){
        this.impactAssessmentFilter.jurisdiction.push(event.option.viewValue);
      }
      
    } else {
      this.impactAssessmentFilter.jurisdiction = [];
      this.impactAssessmentFilter.jurisdiction.push(event.option.viewValue);
    }
    if (this.jInput) {
      this.jInput.nativeElement.value = '';
    }
    this.searchJCntrl.setValue(null);
    this.searchJCntrl.disable();
    this.searchJCntrl.enable();
  }

  removeJurisdiction(status: string): void {
    const index = (this.impactAssessmentFilter.jurisdiction as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactAssessmentFilter.jurisdiction as string[]).splice(index, 1);
    }
  }

  // Keywords events
  add(event: MatChipInputEvent): void {
    if (!this.autoKeyword.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        this.impactAssessmentFilter.searchQuery.push(value.trim());
      }

      event.chipInput!.clear();
      this.keyCtrl.setValue(null);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.searchQuery) {
      this.impactAssessmentFilter.searchQuery.push(event.option.viewValue);
    } else {
      this.impactAssessmentFilter.searchQuery = [];
      this.impactAssessmentFilter.searchQuery.push(event.option.viewValue);
    }
    if (this.keywordInput) {
      this.keywordInput.nativeElement.value = '';
    }
    this.keyCtrl.setValue(null);
    this.keyCtrl.disable();
    this.keyCtrl.enable();
  }

  remove(searchstr: string): void {
    const index = (this.impactAssessmentFilter.searchQuery as string[]).indexOf(searchstr);

    if (index >= 0) {
      (this.impactAssessmentFilter.searchQuery as string[]).splice(index, 1);
    }
  }

  // Update Id events
  removeId(type: string): void {
    if (this.impactAssessmentFilter.updatesDBId == null) return;
    const index = this.impactAssessmentFilter.updatesDBId.indexOf(+type);

    if (index >= 0) {
      this.impactAssessmentFilter.updatesDBId.splice(index, 1);
    }
  }

  addId(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      if (this.impactAssessmentFilter.updatesDBId == null) return;
      this.impactAssessmentFilter.updatesDBId.push(+value.trim());
    }
    event.chipInput!.clear();
  }
}
